import createVueComponent from '../createVueComponent';
export default createVueComponent('arrows-horizontal', 'IconArrowsHorizontal', [
  ['path', { d: 'M7 8l-4 4l4 4', key: 'svg-0' }],
  ['path', { d: 'M17 8l4 4l-4 4', key: 'svg-1' }],
  ['path', { d: 'M3 12l18 0', key: 'svg-2' }],
]);
